import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Form,
  FormFeedback,
  Alert,
  Label,
} from "reactstrap";
// import caspLogo from "../../assets/images/casp-logo.png";
import stageLogo from '../../assets/images/KVP-logo1.svg';
import devLogo from '../../assets/images/PST-logo.png';
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from "../../Components/Common/withRouter";
import { toast } from "react-toastify";
import { sendResetPasswordLink } from "../../api/casp/user";
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../Components/Common/LanguageDropdown";

const ForgetPassword = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validateOnMount: true,
    validationSchema: Yup.object({
      email: Yup.string()
        .strict(true)
        .trim(props.t("Must not include leading and trailing spaces"))
        .required(props.t("Please Enter Your Email")),
    }),
  });

  const handleForgetPasword = async () => {
    try {
      setIsLoading(true);
      const response = await sendResetPasswordLink({
        email: validation.values.email,
      });

      if (response.statusCode === 200) {
        toast.success(response.data.message);
        setIsLoading(false);
        validation.resetForm()
      } else {
        toast.error(response.data.error);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  };
  const matchStageEnv = /\bstage\b/i;
  console.log('process.env.REACT_APP_API_URL ', process.env.REACT_APP_API_URL )

  document.title = props.t("Reset Password ");
  return (
    <React.Fragment>
      <div style={{ float: "right", marginRight: "20px" }}>
        <LanguageDropdown />
      </div>
      <div className="login-bgImg d-flex justify-content-center align-items-center w-100 h-screen">
        <div className="auth-page-content w-100">
          <Container>
            <Row className="justify-content-center mt-3">
              <Col md={8} lg={5}>
                <Card>
                  <CardBody className="p-4">
                    <Row>
                      <Col lg={12}>
                        <div className="text-center text-white-50">
                          <div>
                            <Link to="/" className="auth-logo">
                              <img src={stageLogo} alt="Logo" className="logo_size" />
                            </Link>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="text-center mt-2">
                      <h5 className="mt-4">{props.t("Forget Password")}</h5>
                    </div>
                    <div className="p-2 mt-4">
                      <Alert
                        className="alert-borderless alert-warning text-center mb-2 mx-2"
                        role="alert"
                      >
                        {props.t("Enter your email and instructions will be sent to you!")}
                      </Alert>

                      <Form>
                        <div className="mb-4">
                          {/* <Label className="form-label">Email</Label> */}
                          <Input
                            name="email"
                            className="form-control"
                            placeholder={props.t("Enter email")}
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.email}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="text-center mt-4">
                          <button
                            className="w-100 main-login-btn btn btn-secondary"
                            type="submit"
                            disabled={!validation.isValid || isLoading}
                            onClick={handleForgetPasword}
                          >
                            {props.t("Send Reset Link")}
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(withRouter(ForgetPassword));
